<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useAssistantStore} from '@/stores/assistant'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

const assistantStore = useAssistantStore()
const {isVisible, hasUnreadConversations} = storeToRefs(assistantStore)
const isNewUiEnabled = useNewUiEnabled()
</script>

<template>
  <div class="relative">
    <i class="fa-solid fa-comments text-white" :class="isNewUiEnabled ? 'text-new-lg' : 'text-3xl'"></i>
    <span class="absolute text-xs text-branddark font-bold top-[1px] left-[4px]">
      {{ $t('assistant.icon.label') }}
    </span>
    <span
      v-if="!isVisible && hasUnreadConversations"
      class="absolute top-0 right-1.5 size-3 rounded-full bg-red-500 border-2 border-white"
    ></span>
  </div>
</template>
